import { IconPlus } from "@/assets/icons/geist/IconPlus";
import { IconChevronDownSmall } from "@/assets/icons/geist/IconChevronDownSmall";
import { Button } from "@/components/flexkit/Button";
import { DropdownActions } from "@/components/podkit/dropdown/DropDownActions";
import {
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
} from "@/components/podkit/dropdown/DropDown";
import { TEMPLATE_GROUPS, type AutomationTemplate } from "@/utils/automation-templates";
import type { FC } from "react";
import { withGitpodSize } from "@/assets/icons/utils";

type NewAutomationButtonProps = {
    onTemplateSelect: (template: AutomationTemplate) => void;
    testId?: string;
    trackingId?: string;
    disabled?: boolean;
};

export const NewAutomationButton: FC<NewAutomationButtonProps> = ({
    onTemplateSelect,
    testId,
    trackingId,
    disabled = false,
}) => {
    return (
        <DropdownActions
            triggerTestId={testId}
            contentClassName="w-fit"
            button={
                <Button
                    variant="primary"
                    LeadingIcon={IconPlus}
                    TrailingIcon={IconChevronDownSmall}
                    disabled={disabled}
                    data-tracking-id={trackingId}
                >
                    New Automation
                </Button>
            }
        >
            {TEMPLATE_GROUPS.map(({ id, label, templates }, index) => (
                <DropdownMenuGroup key={id}>
                    {index > 0 && <DropdownMenuSeparator key={`separator-${index}`} />}
                    {label && <DropdownMenuLabel>{label}</DropdownMenuLabel>}
                    {templates.map((template) => (
                        <DropdownMenuItem
                            key={template.id}
                            disabled={!template.enabled}
                            onClick={() => onTemplateSelect(template)}
                            data-testid={`new-automation-template-${template.id}`}
                            data-tracking-id={`select-template-${template.id}`}
                            LeadingIcon={withGitpodSize(template.icon)}
                        >
                            {template.title}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuGroup>
            ))}
        </DropdownActions>
    );
};
